import {Types} from 'mongoose';

export const FORMATS = {
    type: 'Formats',
    category: 'General',
    value: [
        {label: 'Article/Email/Newsletter', _id: new Types.ObjectId('507f1f77bcf86cd799439013')},

        {
            label: 'Brochure/Flyer',
            _id: new Types.ObjectId('507f1f77bcf86cd799439015'),
        },
        {
            label: 'Press Release',
            _id: new Types.ObjectId('507f1f77bcf86cd799439022'),
        },
        {
            label: 'Social Media Post',
            _id: new Types.ObjectId('507f1f77bcf86cd799439023'),
        },
        {
            label: 'Other',
            _id: new Types.ObjectId('506e1e77ece56cd796436021'),
        },
        // {label: 'Audio', _id: new Types.ObjectId('507f1f77bcf86cd799439014')},
        // {label: 'Brown Bag', _id: new Types.ObjectId('507f1f77bcf86cd799439016')},
        // {label: 'Email', _id: new Types.ObjectId('507f1f77bcf86cd799439017')},
        // {
        //     label: 'Media Coverage',
        //     _id: new Types.ObjectId('507f1f77bcf86cd799439018'),
        // },
        // {
        //     label: 'Newsletter',
        //     _id: new Types.ObjectId('507f1f77bcf86cd799439019'),
        // },
        // {label: 'Panel', _id: new Types.ObjectId('507f1f77bcf86cd799439020')},
        // {
        //     label: 'Presentation',
        //     _id: new Types.ObjectId('507f1f77bcf86cd799439021'),
        // },
        // {label: 'Videos', _id: new Types.ObjectId('507f1f77bcf86cd799439024')},
        // {label: 'Webinar', _id: new Types.ObjectId('507f1f77bcf86cd799439025')},
        // {label: 'Workshop', _id: new Types.ObjectId('507f1f77bcf86cd799439026')},
    ].map(d => ({...d, active: true, editable: false})),
};

export const CIRCLE_TYPE = {
    type: 'Circle Types',
    category: 'General',
    value: [
        // {
        //     label: 'Peace Circle',
        //     _id: new Types.ObjectId('507f1f77bcf86cd799439027'),
        // },
        {
            label: 'Community Circle',
            _id: new Types.ObjectId('507f1f77bcf86cd799439029'),
            description:
                'A space for community members to connect, share experiences, and collaboratively address shared concerns',
        },
        {
            label: 'Harm Circle',
            _id: new Types.ObjectId('507f1f77bcf86cd799439028'),
            description:
                'A structured dialogue where individuals acknowledge harm, identify needs, and develop a plan for repair and healing',
        },
        {
            label: 'Restorative Conferencing',
            _id: new Types.ObjectId('513f0f27bcf36cd739337018'),
            description:
                'An intensive restorative process that supports reintegration by repairing serious harm, rebuilding relationships, and fostering accountability',
        },
        // {
        //     label: 'RJ Re-Entry Circle',
        //     _id: new Types.ObjectId('507f1f77bcf86cd799439030'),
        // },
    ].map(d => ({...d, active: true})),
};

export const CONTINUING_EDUCATION_TYPES = {
    type: 'Continuing Education Types',
    category: 'General',
    value: [
        // {
        //     label: 'Basic Training',
        //     _id: new Types.ObjectId('507f1f77bcf86cd799439031'),
        // },
        {
            label: 'Advanced Training',
            _id: new Types.ObjectId('507f1f77bcf86cd799439032'),
            description: 'Any training that builds on Basic Mediation Training skills',
        },
        {
            label: 'Webinar',
            _id: new Types.ObjectId('501f1f77bcf86cd800439001'),
            description: 'Online seminar on conflict resolution topics',
        },
        {
            label: 'Workshop',
            _id: new Types.ObjectId('501f1f77bcf86cd800439002'),
            description: 'Brief, intensive educational program focusing on conflict resolution techniques and skills',
        },
        {
            label: 'Other',
            _id: new Types.ObjectId('507f1f77bcf86cd799439133'),
        },
    ].map(d => ({...d, active: true})),
};

export const COURT_REFERRAL_EVENTS = {
    type: 'Court Referral Events',
    category: 'General',
    value: [
        {
            label: 'ADR Screening',
            _id: new Types.ObjectId('507f1f77bcf86cd799439033'),
        },
        {
            label: 'Complaint Filing',
            _id: new Types.ObjectId('507f1f77bcf86cd799439034'),
        },
        {
            label: 'Pre-Trial Conference',
            _id: new Types.ObjectId('507f1f77bcf86cd799439035'),
        },
        {
            label: 'Show Cause Hearing',
            _id: new Types.ObjectId('507f1f77bcf86cd799439036'),
        },
        {
            label: 'Trial Date',
            _id: new Types.ObjectId('507f1f77bcf86cd799439037'),
        },
        {label: 'Unknown', _id: new Types.ObjectId('507f1f77bcf86cd799439038')},
    ].map(d => ({...d, active: true})),
};

export const COURT_REFERRAL_SOURCE = {
    type: 'Court Referral Source',
    category: 'General',
    value: [
        {
            label: 'ADR Program Screener',
            _id: new Types.ObjectId('507f1f77bcf86cd799439039'),
        },
        {
            label: 'Clerk/Register or Assistant Clerk',
            _id: new Types.ObjectId('507f1f77bcf86cd799439040'),
        },
        {
            label: 'Court Personnel',
            _id: new Types.ObjectId('507f1f77bcf86cd799439041'),
        },
        {label: 'Judge', _id: new Types.ObjectId('507f1f77bcf86cd799439042')},
        {
            label: 'Local ADR Coordinator',
            _id: new Types.ObjectId('507f1f77bcf86cd799439043'),
        },
    ].map(d => ({...d, active: true})),
};

export const MEDIUMS = {
    type: 'Mediums',
    category: 'General',
    value: [
        {label: 'In Person', _id: new Types.ObjectId('507f1f77bcf86cd799439044')},
        {label: 'Remote (Telephone)', _id: new Types.ObjectId('507f1f77bcf86cd799439045')},
        {label: 'Remote (Video)', _id: new Types.ObjectId('507f1f77bcf86cd799439046')},
        {label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439048')},
    ].map(d => ({...d, active: true})),
};

export const RENTAL_ASSISTANCE_TYPES = {
    type: 'Rental Assistance Types',
    category: 'General',
    value: [
        // {label: 'ERMA', _id: new Types.ObjectId('507f1f77bcf86cd799439049')},
        {
            label: 'Multi Sources',
            _id: new Types.ObjectId('507f1f77bcf86cd799439050'),
            description: 'Party has applied to multiple agencies/orgs for rental assistance',
        },
        {
            label: 'RAFT',
            _id: new Types.ObjectId('507f1f77bcf86cd799439051'),
            description: 'Party has applied for Rental Assistance for Families in Transition (RAFT)',
        },
        {
            label: 'Unknown',
            _id: new Types.ObjectId('507f1f77bcf86cd799439052'),
            description: 'Unknown whether party has applied for some sort of rental assistance',
        },
        {
            label: 'Other',
            _id: new Types.ObjectId('507f1f77bcf86cd799439053'),
            description: 'Party has applied for other rental assistance, not listed here',
        },
    ].map(d => ({...d, active: true})),
};

export const SUBSIDY_TYPES = {
    type: 'Subsidy Types',
    category: 'General',
    value: [
        {
            label: 'Income-Based',
            _id: new Types.ObjectId('507f1f77bcf86cd799439054'),
            description:
                'Party has a subsidy that reduces housing costs for that individual or household based on their earnings',
        },
        {
            label: 'Not Subsidized',
            _id: new Types.ObjectId('507f1f77bcf86cd799439055'),
            description: 'Party does not have a subsidy',
        },
        {
            label: 'Unknown',
            _id: new Types.ObjectId('507f1f77bcf86cd799439056'),
            description: 'Unknown whether party has a subsidy or not',
        },
        {
            label: 'Other',
            _id: new Types.ObjectId('507f1f77bcf86cd799439057'),
            description: 'Party has other type of subsidy not listed',
        },
    ].map(d => ({...d, active: true})),
};

export const TRAINING_FOCUS = {
    type: 'Training Focus',
    category: 'General',
    value: [
        {
            label: 'HMP',
            _id: new Types.ObjectId('507f1f77bcf86cd799439058'),
            description: 'Training related to the Housing Mediation Program',
        },
        {
            label: 'PMP',
            _id: new Types.ObjectId('507f1f77bcf86cd799439059'),
            description: 'Training related to the Parent Mediation Program',
        },
        {
            label: 'ReMAp',
            _id: new Types.ObjectId('507f1f77bcf86cd799439060'),
            description: 'Training related to the Re-Entry Mediation Program',
        },
    ].map(d => ({...d, active: true})),
};
